import { render, staticRenderFns } from "./BrokerForexList.vue?vue&type=template&id=27cf16db&"
import script from "./BrokerForexList.vue?vue&type=script&lang=js&"
export * from "./BrokerForexList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports